export const BASIC_FREQUENCY_OPTIONS = [
  {
    label: '30 Days',
    value: 30,
  },
  {
    label: '60 Days',
    value: 60,
  },
  {
    label: '90 Days',
    value: 90,
  },
];

export const SHIPMENT_FREQUENCY_OPTIONS = [
  {
    label: '14 Days',
    value: 14,
  },
  ...BASIC_FREQUENCY_OPTIONS,
];

export const AUTOMATION_TYPES: Record<string, string> = {
  SHIPMENT: 'shipment',
  PAYMENT: 'payment',
};

export const AUTOMATED_PAYMENTS_PURPOSE_OPTIONS = [
  { value: 'One-Time Fee', label: 'One-Time Fee' },
  { value: 'Pending Commission', label: 'Pending Commission' },
  { value: 'Bonus / Challenge Winner', label: 'Bonus / Challenge Winner' },
  { value: 'UGC Video', label: 'UGC Video' },
];

export const AUTOMATED_PAYMENTS_MODAL_STATUS = {
  CREATE: 'create',
  EDIT: 'edit',
  NOT_PRESENT: 'notPresent',
} as const;
